import React, {useState, useEffect, useRef, useCallback} from "react";
//import { GraphQLClient } from 'graphql-request'
import { client } from "@utility/graphql";
import humanize from "humanize-graphql-response";

export const useShopQuery = (query, variables, headers, options) => {

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const variablesRef = useRef();

  useEffect(()=>{
    if(!variablesRef.current || !compairObjectValues(variablesRef.current, variables)){
      setLoading(true);
      variablesRef.current = variables;
      getData();
    }
  }, [query, headers, options, variables])

  const getData = useCallback(async () => {
    if(!client){
      console.error("No GraphQL client to make request");
      return;
    }
    const data = await client.request(query, variables, headers);
    setLoading(false);
    if(options?.keepEdgesAndNodes){
      setData(data);
    }else{
      setData(humanize(data));
    }
  }, [client, query, headers, options, variables])

  return {data, loading, error}

}

const compairObjectValues = (object1, object2) => {
  if(object1 == object2){
    return true;
  }else if(typeof object1 == "object" && typeof object2 == "object"){
    for (const [key, value] of Object.entries(object1)) {
      if(object2[key] != value){
        return false;
      }
    }
    return true;
  }else{
    return false;
  }
}
